import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  pdfExport?: boolean;
  tableLength?: number;
  pdfExportItemsLimit?: number;
}

const calculateTranslateY = (
  tableLength: number,
  pdfExportItemsLimit: number
) => {
  const difference = pdfExportItemsLimit - tableLength;
  const positionInPixels: number = 146 - difference * 7;
  /* 
    146px is a base translateY position for 20 items -
    if the lines limit is changed then this number has to be
    manually changed to new position to set new translateY base in px
  */

  return `translateY(-${Math.round(positionInPixels)}px)`;
};

export const Wrapper = styled.div`
  display: ${(props: IWrapperProps) => (props.pdfExport ? "table" : "flex")};
  flex: 1;
  width: ${(props: IWrapperProps) => props.pdfExport && "1200px"};
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  position: relative;
  box-shadow: ${(props: IWrapperProps) =>
    !props.pdfExport && "rgb(220, 220, 220) 0px 0px 15px"};
  transform: ${(props: IWrapperProps) =>
    props.pdfExport &&
    `scale(0.75) translateX(-154px) ${calculateTranslateY(
      props.tableLength,
      props.pdfExportItemsLimit
    )}`};
  margin: ${(props: IWrapperProps) => !props.pdfExport && "0 10px 100px 10px"};
  overflow: hidden;
  animation-delay: 0.45s;

  ${mediaMaxWidth.mediumDesktop} {
    flex: ${(props: IWrapperProps) => !props.pdfExport && "unset"};
    width: ${(props: IWrapperProps) => !props.pdfExport && "850px"};
    margin: ${(props: IWrapperProps) =>
      !props.pdfExport && "0 auto 100px auto"};
  }

  ${mediaMaxWidth.smallDesktop} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 100px)"};
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 40px)"};
  }

  ${mediaMaxWidth.phone} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 20px)"};
  }
`;

interface ITableProps {
  pdfExport?: boolean;
}

export const Table = styled.div`
  margin: 20px 10px;
  font-size: 0.9em;
  border-left: 1px solid #e4e5e7;

  ${mediaMaxWidth.smallDesktop} {
    margin: ${(props: ITableProps) => !props.pdfExport && "10px"};

    #league-table-tooltip {
      display: none !important;
    }
  }

  ${mediaMaxWidth.phone} {
    font-size: ${(props: IWrapperProps) => !props.pdfExport && "0.8em"};
    line-height: ${(props: IWrapperProps) => !props.pdfExport && "1.15em"};
    margin: ${(props: IWrapperProps) => !props.pdfExport && "15px 0 10px 0"};
  }
`;

interface ITableHeadProps {
  pdfExport?: boolean;
}

export const TableHead = styled.div`
  display: flex;
  background-color: #777;
  color: #fff;
  font-weight: 600;

  ${mediaMaxWidth.smallDesktop} {
    display: ${(props: ITableHeadProps) => !props.pdfExport && "none"};
  }
`;

interface ITableHeadColumnProps {
  flex: number;
  noSmallDesktop?: boolean;
  pdfExport?: boolean;
}

export const TableHeadColumn = styled.div`
  display: flex;
  flex: ${(props: ITableHeadColumnProps) => props.flex};
  justify-content: flex-start;
  padding: ${(props: ITableHeadColumnProps) =>
    props.pdfExport ? "10px 15px" : "15px"};
  border-right: 1px solid #e4e5e7;

  &:last-of-type {
  }

  svg {
    font-size: 0.8em;
    margin-left: 5px;
  }

  ${mediaMaxWidth.smallDesktop} {
    display: ${(props: ITableHeadColumnProps) =>
      props.noSmallDesktop && !props.pdfExport && "none"};
  }
`;

export const AvatarWrapper = styled.div`
  width: 30px;
  margin-right: 15px;

  ${mediaMaxWidth.smallDesktop} {
    width: 25px;
  }
`;

export const Avatar = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop} {
    width: 25px;
    height: 25px;
  }
`;

interface ICompanyNameProps {
  isOpen: boolean;
  alt: string;
  pdfExport?: boolean;
}

export const CompanyNameWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const CompanyName = styled.a`
  display: flex;
  color: #333 !important;
  text-decoration: ${(props: ICompanyNameProps) =>
    props.pdfExport ? "none" : "underline !important"};

  &:hover {
    color: #f2008c !important;
  }

  ${mediaMaxWidth.smallDesktop} {
    flex: unset;
    font-weight: ${(props: ICompanyNameProps) =>
      props.isOpen && !props.pdfExport && "700"};
  }
`;

export const TableHeadColumnText = styled.div``;

interface ITableColumnProps {
  flex: number;
  noSmallDesktop?: boolean;
  rank?: boolean;
  pdfExport?: boolean;
}

export const TableColumn = styled.div`
  display: flex;
  padding: ${(props: ITableColumnProps) =>
    props.pdfExport ? "10px 15px" : "15px"};
  flex: ${(props: ITableColumnProps) => props.flex};
  justify-content: flex-start;
  align-items: center;
  border-right: 1px solid #e4e5e7;
  position: relative;

  ${mediaMaxWidth.smallDesktop} {
    display: ${(props) => props.noSmallDesktop && !props.pdfExport && "none"};
    flex: ${(props: ITableColumnProps) =>
      props.rank && !props.pdfExport && "unset"};
    width: ${(props: ITableColumnProps) =>
      props.rank && !props.pdfExport && "40px"};
    justify-content: ${(props: ITableColumnProps) =>
      props.rank && !props.pdfExport && "flex-end"};
    padding: ${(props: ITableColumnProps) =>
      props.rank && !props.pdfExport && "0 15px"};
  }
`;

interface IToggleTriggerProps {
  isOpen: boolean;
}

export const ToggleTrigger = styled.button`
  position: absolute;
  right: 10px;
  font-size: 1.2em;
  background: none;
  transition: 0.2s ease-in-out;
  transform: ${(props: IToggleTriggerProps) =>
    props.isOpen && "rotate(180deg)"};
  border: none;

  &:focus {
    outline: none;
  }

  ${mediaMinWidth.smallDesktop} {
    display: none;
  }
`;

interface ITableLineWrapperProps {
  pdfExport?: boolean;
}

export const TableLineWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaMaxWidth.smallDesktop} {
    &:last-of-type {
      border-bottom: ${(props: ITableLineWrapperProps) =>
        !props.pdfExport && "1px solid #e4e5e7"};
    }
  }
`;

interface ITableLineProps {
  pdfExport?: boolean;
}

export const TableLine = styled.div`
  display: flex;
  border-bottom: 1px solid #e4e5e7;
  min-height: ${(props: ITableLineProps) => !props.pdfExport && "61px"};

  &:last-of-type {
    ${TableColumn} {
      &.last {
      }
    }
  }

  ${mediaMaxWidth.smallDesktop} {
    min-height: ${(props: IWrapperProps) => !props.pdfExport && "unset"};
    height: ${(props: IWrapperProps) => !props.pdfExport && "50px"};
    cursor: ${(props: IWrapperProps) => !props.pdfExport && "pointer"};
    border-bottom: ${(props: IWrapperProps) => !props.pdfExport && "none"};
    border-top: ${(props: IWrapperProps) =>
      !props.pdfExport && "1px solid #e4e5e7"};
  }

  ${mediaMaxWidth.phone} {
    height: ${(props: IWrapperProps) => !props.pdfExport && "45px"};
  }
`;

export const TableLineExpandedContent = styled.div`
  border-top: 1px solid #e4e5e7;
  border-right: 1px solid #e4e5e7;
  padding: 15px 15px 15px 55px;

  ${mediaMinWidth.smallDesktop} {
    display: none;
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 15px 15px 60px;
  }
`;

export const ExpandedLine = styled.div`
  display: flex;
  margin: 5px 0;
`;

interface IExpandedColumnProps {
  width: number;
}

export const ExpandedColumn = styled.div`
  width: ${(props: IExpandedColumnProps) => `${props.width}px`};
  display: flex;
  align-items: center;

  ${mediaMaxWidth.phone} {
    width: ${(props: IExpandedColumnProps) => `${props.width - 20}px`};
  }

  ${mediaMaxWidth.smallPhone} {
    width: ${(props: IExpandedColumnProps) => `${props.width - 40}px`};
  }
`;

export const ToolTip = styled.div`
  font-size: 0.75em;
  color: #999;
  margin-left: 5px;
`;

export const NoData = styled.div`
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
